export const WIDGETS_SLICE = 'WIDGETS_SLICE';
